import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

import { FONT_DISPLAY } from "../../theme/tokens";
import { KodeHaze } from "../effects/KodeEffects";

const styles = (theme) => ({
  root: {
    position: "relative",
    minHeight: "60vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    overflow: "hidden",
  },
  content: {
    position: "relative",
    zIndex: 1,
    maxWidth: 640,
  },
  // Цифры водяным знаком, сообщение поверх: крупная типографика без крупного шума.
  watermark: {
    fontFamily: FONT_DISPLAY,
    fontWeight: 800,
    fontSize: "clamp(80px, 12vw, 180px)",
    lineHeight: 1,
    color: theme.palette.action.hover,
    userSelect: "none",
  },
  eyebrow: {
    color: theme.palette.text.disabled,
    display: "block",
    marginBottom: theme.spacing(1),
  },
  message: {
    marginTop: theme.spacing(-4),
    marginBottom: theme.spacing(4),
  },
});

class AllureDockerNotFound extends Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <KodeHaze position="center" />
        <div className={classes.content}>
          <Typography variant="overline" className={classes.eyebrow}>
            Not found
          </Typography>
          <div className={classes.watermark} aria-hidden="true">
            404
          </div>
          <Typography variant="h4" component="h1" className={classes.message}>
            This page does not exist
          </Typography>
          <Button component={Link} to="/" variant="outlined">
            Back to projects
          </Button>
        </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(AllureDockerNotFound);
